import axios from "axios";
import { IProduct } from "../models/IProduct";
import { API_BASE_URL } from "../config/api";

class ProductService {
  private productsUrl = `${API_BASE_URL}/api/v1/products`;
  private fabricsUrl = `${API_BASE_URL}/api/v1/fabrics`;

  async getProducts() {
    try {
      const response = await axios.get<IProduct[]>(this.productsUrl);
      return response.data;
    } catch {
      const fallback = await axios.get<IProduct[]>(this.fabricsUrl);
      return fallback.data;
    }
  }

  async getProductById(id: number) {
    try {
      const response = await axios.get<IProduct>(`${this.productsUrl}/${id}`);
      return response.data;
    } catch {
      const fallback = await axios.get<IProduct>(`${this.fabricsUrl}/${id}`);
      return fallback.data;
    }
  }

  async getProductByArticle(article: string) {
    try {
      const response = await axios.get<IProduct>(`${this.productsUrl}/by-article/${encodeURIComponent(article)}`);
      return response.data;
    } catch {
      const products = await this.getProducts();
      const fallback = products.find((item) => item.article.toLowerCase() === article.toLowerCase());
      if (!fallback) {
        throw new Error("Product not found");
      }
      return fallback;
    }
  }
}

export const productService = new ProductService();
